<form
  *ngIf="customFieldsArray.controls"
  (submit)="$event.preventDefault()"
  (keydown.enter)="$event.preventDefault()"
  class="field-dialog__content__scroll p-24"
  [ngClass]="{ 'with-disclaimer': isViewMode }"
  fxLayout="column"
  autocomplete="off"
  name="form"
  ngNoForm
  fusePerfectScrollbar
>
  <div *ngIf="!customFieldsArray.controls.length" fxLayout="column" fxLayoutAlign="center center" class="p-24">
    <p fxFlex="100" fxLayout="row">
      <mat-icon class="no-results-icon">ballot</mat-icon>
    </p>
    <span class="h3">
      {{ 'EQUIPMENTS.ERRORS.NO_CUSTOM_FIELDS' | translate }}
    </span>
  </div>

  <div *ngIf="customFieldsArray.controls.length">
    <div *ngFor="let customField of customFieldsArray.controls; index as index">
      <div fxLayout="row" fxLayoutAlign="start center">
        <mat-form-field *ngIf="customField.value.type === 'question'" appearance="legacy" fxFlex="100">
          <mat-label>{{ customField.value.name }}</mat-label>
          <input [formControl]="customField.get('value')" matInput [required]="customField.value.required" />
          <mat-error *ngIf="customField.get('value').hasError('required')">
            {{ 'EQUIPMENTS.ERRORS.CUSTOM_FIELD_REQUIRED' | translate }}
          </mat-error>
        </mat-form-field>
        <mat-form-field *ngIf="customField.value.type === 'multipleChoice'" appearance="legacy" fxFlex="100">
          <mat-label>{{ customField.value.name }}</mat-label>
          <mat-select [formControl]="customField.get('value')" [required]="customField.value.required">
            <mat-option *ngFor="let option of customField.value.options" [value]="option.value">
              {{ option.value }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="customField.get('value').hasError('required')">
            {{ 'EQUIPMENTS.ERRORS.CUSTOM_FIELD_REQUIRED' | translate }}
          </mat-error>
        </mat-form-field>
        <mat-form-field *ngIf="customField.value.type === 'date'" appearance="legacy" fxFlex="100">
          <mat-label>{{ customField.value.name }}</mat-label>
          <input
            matInput
            placeholder="00/00/0000"
            [formControl]="customField.get('value')"
            [matDatepicker]="questionPicker"
            [required]="customField.value.required"
          />
          <mat-datepicker-toggle matSuffix [for]="questionPicker"></mat-datepicker-toggle>
          <mat-datepicker #questionPicker></mat-datepicker>
          <mat-error *ngIf="customField.get('value').hasError('required')">
            {{ 'EQUIPMENTS.ERRORS.CUSTOM_FIELD_REQUIRED' | translate }}
          </mat-error>
        </mat-form-field>
        <mat-form-field
          class="numeric-input"
          *ngIf="customField.value.type === 'number'"
          appearance="legacy"
          fxFlex="100"
        >
          <mat-label>{{ customField.value.name }}</mat-label>
          <input
            type="number"
            [formControl]="customField.get('value')"
            matInput
            [required]="customField.value.required"
          />
          <mat-error *ngIf="customField.get('value').hasError('required')">
            {{ 'EQUIPMENTS.ERRORS.CUSTOM_FIELD_REQUIRED' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
</form>
